<template>
  <article class="panel p-bottom-4" data-cy="request-panel-header">
    <div class="panel-heading has-background-light">
      <p class="has-text-weight-semibold is-size-4">Request</p>
      <NrIconButton
        v-if="$can('manage', 'Request')"
        @click="setDisplayEditRequestTextBox(true)"
        :icon="{ name: 'pencil-alt', type: 'regular' }"
        aria-label="Edit request text"
        variant="minimal-neutral"
      />
    </div>
    <div v-if="!filteredRequestLoading">
      <div v-if="showMoreDescription">
        <div class="panel-block">
          <div class="content" v-html="sanitizedDescription" />
        </div>
        <div class="panel-block request-show-more-btn">
          <NrButton
            variant="minimal-neutral"
            @click="showMoreDescription = !showMoreDescription"
          >
            Show less
          </NrButton>
        </div>
      </div>
      <div
        v-else-if="sanitizedDescription && sanitizedDescription.length > 700"
      >
        <div class="panel-block">
          <div class="content" v-html="shortDescription" />
        </div>
        <div class="panel-block request-show-more-btn">
          <NrButton
            variant="minimal-neutral"
            @click="showMoreDescription = true"
          >
            Show more
          </NrButton>
        </div>
      </div>
      <div
        v-else-if="sanitizedDescription && sanitizedDescription.length <= 700"
      >
        <div class="panel-block">
          <div class="content" v-html="sanitizedDescription" />
        </div>
      </div>
    </div>
    <NrLoadingAnimation v-else :count="3" />
  </article>
</template>

<script>
import truncate from 'lodash/truncate'
import { mapActions, mapState } from 'vuex'
import NrButton from '@nextrequestco/components/src/components/NrButton/nr-button'
import NrIconButton from '@nextrequestco/components/src/components/NrIconButton/nr-icon-button.vue'
import NrLoadingAnimation from '@nextrequestco/components/src/components/NrLoadingAnimation/nr-loading-animation.vue'

export default {
  name: 'RequestInfoHeader',
  components: {
    NrButton,
    NrIconButton,
    NrLoadingAnimation
  },
  props: {
    sanitizedDescription: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showMoreDescription: false
    }
  },
  computed: {
    ...mapState('request_show', ['request', 'filteredRequestLoading']),
    shortDescription() {
      return truncate(this.sanitizedDescription, { length: '700' })
    }
  },
  methods: {
    ...mapActions('request_show', ['setDisplayEditRequestTextBox'])
  }
}
</script>

<style scoped lang="scss">
.panel-heading {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.nr-button {
  &:active,
  &:focus,
  &:hover {
    color: #6e6e87;
    box-shadow: 0 0 0 0.125em rgba(48, 48, 59, 0.25);
    outline: none;
  }
}

.content {
  max-width: 100%;
  word-wrap: break-word;
}
</style>
